module.exports = __webpack_public_path__ + "img/email-grey.f466d11f.svg";